// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".active_tab[data-v-3d5b84e1]{color:#5e60ce;border-color:#5e60ce}.inactive_tab[data-v-3d5b84e1]:hover{border-color:transparent}", ""]);
// Exports
module.exports = exports;
